import React from 'react'
import styles from './MicrositeDomainTypeBadge.module.css'

/**
 * MicrositeDomainTypeBadge
 * CUSTOM (salon-owned domain) vs SUBDOMAIN (*.lokacipro.com) pill.
 *
 * Usage:
 *   <MicrositeDomainTypeBadge value={domain.domainType} />
 */
const MicrositeDomainTypeBadge = ({ value }) => {
    const isCustom = value === 'CUSTOM'
    return (
        <span className={`${styles.badge} ${isCustom ? styles.tone_custom : styles.tone_subdomain}`}>
            {isCustom ? 'Custom domain' : 'Subdomain'}
        </span>
    )
}

export default MicrositeDomainTypeBadge